import { Spinner } from 'reactstrap';
import logo from '../../../assets/images/logo.svg';

const LogoSpinner = (): JSX.Element => (
    <div className="logo-spinner">
        <img src={logo} alt="logo" height="90" />
        <Spinner type="grow" />
    </div>
);

export default LogoSpinner;
